<ion-content fullscreen>
  <div class="splash-container">
    <div class="logo">
      <img class="logo-img" [src]="appInstanceLogo" alt="Seutuluotsi logo" />
      <div class="logo-text">{{appInstanceName}}</div>
    </div>
    <div class="instructions">
      <h4 class="add-margin-bottom">{{'desktop-redirect.h2' | translate}}</h4>
      <p class="short" [innerHTML]="'desktop-redirect.short' | translate"></p>
      <p>{{link}}</p>
      <p class="long add-margin-bottom">{{'desktop-redirect.long' | translate}}</p>
    </div>
    <div>
      <ion-button size="large" fill="clear" class="continue-button" (click)="dismissModal()"
        >{{'desktop-redirect.continue-with-desktop' | translate}}</ion-button
      >
    </div>
    <div class="language-selector">
      <div *ngFor="let language of languages" class="language">
        <a
          (click)="selectLanguage(language)"
          (keyup.enter)="selectLanguage(language)"
          role="button"
          tabindex="0"
        >
          {{(language + '-language') | translate }}
        </a>
      </div>
    </div>
    <div class="terms">
      <a
        (click)="navigateToPrivacyPolicy('fi')"
        (keyup.enter)="navigateToPrivacyPolicy('fi')"
        role="link"
        tabindex="0"
        >Tietosuojaseloste</a
      >
      <a
        (click)="navigateToPrivacyPolicy('en')"
        (keyup.enter)="navigateToPrivacyPolicy('en')"
        role="link"
        tabindex="0"
        >Privacy Policy</a
      >
    </div>
  </div>
</ion-content>
